// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__A96LK","actionsCol":"EnrolledClinics_actionsCol__339kZ"};